<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Excel Havuzu</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="100px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="startDate"
            label="Baş. Tarihi"
            prepend-icon="event"
            single-line
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          locale="tr-TR"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="100px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="endDate"
            label="Bit. Tarihi"
            prepend-icon="event"
            single-line
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="endDate"
          locale="tr-TR"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        @keyup.enter.native="initialize"
        append-icon="search"
        label="Ara"
        single-line
        hide-details
      ></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
    </v-toolbar>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="poolOrders"
      :rows-per-page-items="pageItems"
      :pagination.sync="pagination"
      select-all
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-left"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td>
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td>{{ props.item.indicator }}</td>
          <!-- <td>{{ props.item.createdDate |formatDate }}</td> -->
          <td>{{ props.item.orderDate | formatDate }}</td>
          <td>{{ props.item.barcode }}</td>
          <td>{{ props.item.iban }}</td>
          <td>{{ props.item.identityNo }}</td>
          <td>{{ props.item.shipmentNo }}</td>
          <td>{{ props.item.recipientName }}</td>
          <td>{{ props.item.productName }}</td>
          <td>{{ props.item.quantity }}</td>
          <td>{{ props.item.amount | formatMoney }}</td>
          <td>{{ props.item.totalAmount | formatMoney }}</td>

          <td v-for="formula in props.item.formulas">
            {{ formula.replace(",", ".") | formatMoney }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md9></v-flex>
      <v-flex xs12 md3>
        <download-excel
          class="v-btn warning"
          :data="selected"
          :fields="json_fields"
          worksheet="My Worksheet"
          name="filename.xls"
          >Excele Aktar</download-excel
        >
        <v-btn color="primary" dark @click="deleteAction" class="mb-2"
          >Sil</v-btn
        >
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    menu2: false,
    pagination: {
      sortBy: "indicator",
    },
    select: { id: -1, value: "Tümü" },
    selectedAction: { id: -1, value: "Durum Seç" },
    search: null,
    selected: [],
    poolOrders: [],
    pageItems: [
      500,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    headers: [
      { text: "indicator", value: "indicator" },
      // { text: "Excel Tarih", value: "createdDate" },
      { text: "orderDate", value: "orderDate" },
      { text: "barcode", value: "barcode" },
      { text: "iban", value: "iban" },
      { text: "tc", value: "identityNo" },
      { text: "shipmentNo", value: "shipmentNo" },
      { text: "recipientName", value: "recipientName" },
      { text: "productName", value: "productName" },
      { text: "quantity", value: "quantity" },
      { text: "amount", value: "amount" },
      { text: "totalAmount", value: "totalAmount" },
    ],
    json_fields: {
      "Sıra No": "indicator",
      Tarih: {
        field: "orderDate",
        callback: (value) => {
          return `${moment(String(value)).format("DD.MM.YYYY HH:mm")}`;
        },
      },

      Barcode: "barcode",
      Tc: "identityNo",
      "Sipariş No": "shipmentNo",
      İsim: "recipientName",
      Ürün: "productName",
      İban: "iban",
      Miktar: "quantity",
      "Birim Fiyat": {
        field: "amount",
        callback: (value) => {
          return `${value.toString().replace(".", ",")}`;
        },
      },

      // "Fatura Tutarı": {
      //   field: "totalAmount",
      //   callback: value => {
      //     return `${value.toString().replace(".", ",")}`;
      //   }
      // }
      // "Telephone 2": {
      //   field: "phone.landline",
      //   callback: value => {
      //     return `Landline Phone - ${value}`;
      //   }
      //}
    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    multiSplit(str, delimiter) {
      if (!(delimiter instanceof Array)) return str.split(delimiter);
      if (!delimiter || delimiter.length == 0) return [str];
      var hashSet = new Set(delimiter);
      if (hashSet.has("")) return str.split("");
      var lastIndex = 0;
      var result = [];
      var lastFormula;
      for (var i = 0; i < str.length; i++) {
        if (hashSet.has(str[i])) {
          lastFormula = str[i];
          result.push({ value: str.substring(lastIndex, i), key: lastFormula });
          lastIndex = i + 1;
        }
      }
      result.push({ value: str.substring(lastIndex), key: lastFormula });
      return result;
    },
    async initialize() {
      await this.$store.dispatch("poolOrders/searchPoolOrder", {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        state: this.select.id,
      });
      this.poolOrders = this.$store.state.poolOrders.all.sort((a, b) =>
        a.indicator > b.indicator ? 1 : -1
      );
      this.poolOrders.forEach((poolorder) => {
        poolorder.formulas = {};
        this.$store.state.poolFormulas.all
          .sort((a, b) => (a.order > b.order ? 1 : -1))
          .forEach((element) => {
            let arr = this.multiSplit(element.formula, ["*", "/"]);
            let total = 1;

            for (let index = 0; index < arr.length; index++) {
              const elm = arr[index];
              if (elm.value.isNumeric(elm.value)) {
                elm.value = elm.value.replace(",", ".");
                if (arr[index - 1]) {
                  if (total == 1) total = 0;
                  total += parseFloat(elm.value);
                } else {
                  switch (elm.key) {
                    case "*":
                      total *= parseFloat(elm.value);
                      break;
                    case "/":
                      total /= parseFloat(elm.value);
                      break;
                    case "-":
                      total -= parseFloat(elm.value);
                      break;
                    case "+":
                      total += parseFloat(elm.value);
                      break;
                  }
                }
              } else {
                var deger;

                deger = poolorder[elm.value];

                if (!arr[index - 1] && deger) {
                  if (total == 1) total = 0;

                  total += parseFloat(deger);
                } else if (arr[index - 1] && !deger) {
                  deger = this.$store.state.poolFormulas.all.find(
                    (word) => word.name == elm.value
                  ).total;
                  total = parseFloat(deger);
                } else {
                  switch (elm.key) {
                    case "*":
                      total *= parseFloat(deger);
                      break;
                    case "/":
                      total /= parseFloat(deger);
                      break;
                    case "-":
                      total += parseFloat(deger);
                      break;
                    case "+":
                      total -= parseFloat(deger);
                      break;
                  }

                  // eslint-disable-next-line no-console
                  console.log("non numeric", elm);
                }
              }
            }
            element.total = total;
            poolorder.formulas[
              element.name.replace(".", "-")
            ] = element.total.toString().replace(".", ",");
          });
      });
    },
    editItem(item) {
      this.$router.push({ name: "poolOrder-detail", params: { id: item.id } });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("poolOrders/deletePoolOrder", item);
    },
    // eslint-disable-next-line no-unused-vars
    async deleteAction(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        (await this.$store.dispatch(
          "poolOrders/bulkDeletePoolOrder",
          this.selected.map(function(item) {
            return item.id;
          })
        ));
      this.selected = [];
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.poolOrders.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("poolFormulas/searchFormula", {
      search: this.search,
      state: this.select.id,
    });
    await this.initialize();

    this.$store.state.poolFormulas.all
      .sort((a, b) => (a.order > b.order ? 1 : -1))
      .forEach((element) => {
        this.headers.push({
          text: element.name.replace(".", "-"),
          value: element.name,
        });
        this.json_fields[element.name.replace(".", "-")] =
          "formulas." + [element.name.replace(".", "-")];
      });
  },
};
</script>
